import { PROD_HOSTNAME, SUBDOMAIN_API_MAP } from './url.constant';
import { UrlProperties } from './url.model';

export function extractUrlProperties(): UrlProperties {
  const { hostname, pathname } = window.location;

  const subdomain = hostname === PROD_HOSTNAME ? PROD_HOSTNAME : hostname.split('.')[0];

  const api = SUBDOMAIN_API_MAP[subdomain] ?? 'PROD_API';

  const segments = pathname.split('/').filter(Boolean);
  const studyIndex = segments.indexOf('study');
  const studyId = segments[studyIndex + 1];

  return { api, studyId };
}
